export default async function initJumpMenu() {
  const element = document.querySelector('[data-js-module="jump-menu"]');

  if (element) {
    const { default: JumpMenu } = await import(/* webpackChunkName: "jump-menu" */ './jump-menu');
    new JumpMenu(element);
  }
}
